import { useTranslation } from '@crehana/i18n';

import type { TKeys } from '../i18n/types';

export const useHomeTranslations = () => {
  return useTranslation<TKeys>();
};
